<!-- Added form to disable autocomplete-->
<form autocomplete="off">
  <div class="nav-container" [class.box-shadow-bttm]="hasScrolledDown">
    <div class="flex flex-row items-center  {{ currentPageHeader ? 'leftSide' : '' }}">
      @if (currentPageHeader === 'Account settings' || currentPageHeader === 'Organization & users') {
        <app-button
          data-qa="hov-nav-bar-back-button"
          [size]="'small'"
          [type]="'grey-accent'"
          [iconName]="'back.svg'"
          queryParamsHandling="preserve"
          (buttonClick)="goBack()">
          Back
        </app-button>
      }
      <span id="header">{{ currentPageHeader }}</span>
      @if (currentPageHeader) {
        <div class="xAxis-whitespace-0p75"></div>
      }
      @if (showElements.orgPicker) {
        <app-org-picker
          data-qa="org-picker"
          [organizationsWithRoles]="organizationsWithRoles"
          [currentService]="currentService"
          [isNewOrgCanBeCreated]="is.showCreateOrgBtn"
          (orgSelectionEmitter)="changeSelectedOrganization($event)"
          (createOrgEmitter)="openCreateOrgModal()">
        </app-org-picker>
      }
    </div>
    @if (showElements.logo) {
      <app-orca-logo
        class="absolute left-1/2 -translate-x-1/2"
        [logoWidthRem]="5"
        [logoHeightRem]="1"
        [divStyling]="'mobile'"
        [logoType]="'black'">
      </app-orca-logo>
    }
    <div class="flex flex-row items-center rightSide">
      @if (showElements.playShareOrgButtons) {
        <app-button
          data-qa="about-orca-button"
          [type]="'blue'"
          [size]="'small'"
          [showIcon]="'left'"
          [iconName]="'play.svg'"
          [bordersSquaredShape]="'full'"
          (buttonClick)="onlyShowVideo()">
          {{ videoButtonText }}
        </app-button>
        <app-button
          data-qa="share-button"
          [type]="'accent'"
          [size]="'small'"
          [showIcon]="'left'"
          [iconName]="'users.svg'"
          [bordersSquaredShape]="'full'"
          (buttonClick)="openShareModal()">
          Share
        </app-button>
        <app-button
          data-qa="organization-button"
          [type]="'grey'"
          [size]="'small'"
          [showIcon]="'left'"
          [iconName]="'organization-settings.svg'"
          [bordersSquaredShape]="'full'"
          (buttonClick)="clickOnOrganization()">
          Organization
        </app-button>
      }
      <app-nav-avatar/>
    </div>
  </div>
</form>

@if (is.showAboutOrcaModal) {
  <app-video-player
    [vimeoUrl]="chosenVideoToShow"
    (closeButtonClickedEmitter)="closeAboutOrcaModal()"
  />
}

@if (is.showShareModal) {
  <app-share-modal
    [currentEmployee]="currentEmployee"
    [employees]="employees"
    [currentOrganization]="selectedOrganization"
    (openInviteMemberModalEmitter)="openInviteMemberModal()"
    (closeButtonClickedEmitter)="closeShareModal()"
    (deleteUserEmitter)="openDeleteMemberModal($event)"
    (updateRole)="onUpdateMember($event)"
    (resendInviteEmitter)="resendInvite($event)"
  />
}

@if (is.showInviteMemberModal) {
  <app-modal-team-member
    (applyEmitter)="addMember($event)"
    (cancelEmitter)="closeInviteMemberModal()"
  />
}

@if (is.showDeleteEmployeeModal) {
  <app-modal-dialog
    [header]="'Delete member'"
    [customUnderstandString]="deleteMemberText"
    [showIUnderstand]="false"
    (isConfirmed)="closeModalDeleteUser($event)"
  />
}

@if (is.showCreateOrgModal) {
  <app-modal-container
    [bigSize]="false"
    [buttons]="{ close: true }"
    (closeButtonClicked)="is.showCreateOrgModal = false">
    <app-new-organization
      [inModalMode]="true"
      (newOrgCreated)="is.showCreateOrgModal = false"
    />
  </app-modal-container>
}
